<template>
  <div>
    <QsDrawer
      title="调整部门车辆"
      :visible.sync="visible"
      :append-to-body="true"
      :before-close="handleDrawerClose"
      @open="handleOpen"
      cusSize="lg"
    >
      <div class="drawer_content">
        <div class="d-top">
          <div class="d-top-left">
            <span>所属部门</span>
            <span>
              <DeptSelect
                v-model="deptId"
                :multiple="false"
                :clearable="false"
                :is-all="true"
                @selectedNodesChange="handleDeptChange"
              />
            </span>
          </div>
          <div class="d-top-right">
            <el-button :disabled="!disabledNextStep" @click="handleNextStep"
              >调整所选</el-button
            >
            <el-button @click="handleAllVchicle">调整全部</el-button>
            <el-button @click="handleCustomBatch">自定义批量</el-button>
          </div>
        </div>
        <el-table
          class="d-table"
          v-loading="loading"
          ref="multipleTable"
          :data="carIdData"
          :height="`calc(100% - 97px)`"
          tooltip-effect="dark"
          @select="handleRowSelectionChange"
          @select-all="handleAllSelectionChange"
        >
          <el-table-column type="selection" width="25" />
          <el-table-column prop="plateNoOrVin" label="车辆信息" />
          <el-table-column prop="deptName" label="当前所属部门" />
        </el-table>
        <div class="footer">
          <div>
            <span>共 {{ totalNum }} 条</span>
            <span>，本页已选 {{ currentPageCheckNum }} 条</span>
          </div>
          <div>
            <el-pagination
              layout="prev, pager, next"
              :total="totalNum"
              :page-size="pageSize"
              :pager-count="5"
              :current-page="pageNum"
              @current-change="handleCurrentChange"
            />
          </div>
        </div>
      </div>
    </QsDrawer>
    <SetVechicleDeptDrawer ref="setDeptDrawer" @refresh="handleRefresh" />
  </div>
</template>
<script setup>
import { getDeptCarList } from '@/api/domain/organize'
import { computed, nextTick, ref } from 'vue'
import { SCENE_MAPPING } from '../hooks'
import SetVechicleDeptDrawer from './setVechicleDeptDrawer'

const pageNum = ref(1)
const totalNum = ref(0)
const pageSize = ref(20)

const multipleTable = ref(null)
const multipleTableCheckRows = ref([])
// 定义抽屉弹窗
const visible = ref(false)
const deptId = ref('')
const currentNode = ref('')
const loading = ref(false)
const setDeptDrawer = ref(null) // 调整车辆
// 获取部门车辆列表
const carIdData = ref([])

const openDrawer = (node) => {
  deptId.value = node.id
  currentNode.value = node
  visible.value = true
}
const closeDrawer = () => {
  carIdData.value = []
  visible.value = false
}

// 变更选中状态
const setCurrentTableRowSelection = () => {
  nextTick(() => {
    if (!multipleTable.value) return
    carIdData.value.forEach((row) => {
      const index = multipleTableCheckRows.value.findIndex(
        ({ id }) => row.id === id,
      )
      multipleTable.value.toggleRowSelection(row, index !== -1)
    })
  })
}
// 当前行选中时候 添加或者存储id
const handleRowSelectionChange = (_, row) => {
  const index = multipleTableCheckRows.value.findIndex(
    ({ id }) => row.id === id,
  )
  if (index === -1) {
    multipleTableCheckRows.value.push(row)
    return
  }
  multipleTableCheckRows.value.splice(index, 1)
}
const handleAllSelectionChange = (selection) => {
  carIdData.value.forEach((row) => {
    const index = multipleTableCheckRows.value.findIndex(
      ({ id }) => row.id === id,
    )
    // selection 为空的时候就是 当前页面全部都剔除
    if (selection.length === 0) {
      index !== -1 && multipleTableCheckRows.value.splice(index, 1)
      return
    }
    index === -1 && multipleTableCheckRows.value.push(row)
  })
}

// 点击下一步 调整部门
const handleNextStep = () => {
  setDeptDrawer.value.open({
    list: multipleTableCheckRows.value,
    enterScene: SCENE_MAPPING.CHOOSE,
  })
}
// 自定义调整
const handleCustomBatch = () => {
  // 将当前选中的部门车辆id 提交给子组件
  setDeptDrawer.value.open({
    list: [],
    enterScene: SCENE_MAPPING.CUSTMER,
  })
}
// 全部调整
const handleAllVchicle = () => {
  // 将当前选中的部门车辆id 提交给子组件
  setDeptDrawer.value.open({
    list: carIdData.value,
    enterScene: SCENE_MAPPING.CHOOSE,
    isAll: true,
    oriDeptId: deptId.value,
  })
}
// 当前页所选择数量
const currentPageCheckNum = computed(
  () => multipleTable.value?.selection?.length,
)
// 是否可以调整按钮状态
const disabledNextStep = computed(() => multipleTableCheckRows.value.length > 0)

// 左侧所有的部门车辆
const getRootCars = () => {
  loading.value = true
  carIdData.value = []
  getDeptCarList({
    deptId: currentNode.value.pid === 0 ? null : currentNode.value.id,
    pageNum: pageNum.value,
    pageSize: pageSize.value,
  })
    .then(({ code, data }) => {
      if (code === 1) {
        carIdData.value = data?.items.map((item) => ({
          ...item,
          plateNoOrVin: item.plateNo || item.vin,
        }))
        totalNum.value = data?.totalNum
        // 重置当前页面的选中状态
        setCurrentTableRowSelection()
      }
    })
    .finally(() => {
      loading.value = false
    })
}

const handleDeptChange = (node) => {
  currentNode.value = node[0]
  pageNum.value = 1
  multipleTableCheckRows.value = []
  getRootCars()
}

// 刷新页面
const handleRefresh = () => {
  pageNum.value = 1
  getRootCars()
}

const handleCurrentChange = (val) => {
  pageNum.value = val
  multipleTableCheckRows.value = []
  getRootCars()
}

const handleDrawerClose = () => {
  currentNode.value = null
  multipleTable.value = null
  carIdData.value = []
  multipleTableCheckRows.value = []
  loading.value = false
  visible.value = false
}

// 抽屉展开 获取table 部门车辆数据
const handleOpen = () => getRootCars()

defineExpose({
  open: openDrawer,
  close: closeDrawer,
})
</script>

<style lang="scss" scoped>
::v-deep .custom-lg-drawer.rtl .el-drawer__body {
  padding-bottom: 0;
}
.drawer_content {
  height: 100%;
  overflow: hidden;
  padding: 0 16px;
  transform: scale(1);
}
::v-deep .tree-select{
  width: 100%;
}
::v-deep .el-select{
    width: 100%;
}
.d-top {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 32px;
  margin-bottom: 16px;
  justify-content: space-between;
  align-items: center;
  &-left {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    > span:first-child {
      font-family: PingFang SC;
      font-size: 14px;
      font-weight: normal;
      line-height: 22px;
      letter-spacing: 0em;
      margin-right: 8px;
      /* 信息/font-black2 */
      /* 样式描述：次强调、辅助信息 */
      color: rgba(0, 0, 0, 0.6);
    }
    > span:last-child {
      display: inline-block;
      width: 140px;
    }
  }
  &-right {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
  }
}
.d-table {
  width: 100%;
  margin-bottom: 58px;
}

::v-deep .el-table {
  width: 100%;
  .el-table__header-wrapper table,
  .el-table__body-wrapper table {
    width: 100% !important;
  }
  .el-table__body,
  .el-table__footer,
  .el-table__header {
    table-layout: auto;
  }
}
.footer {
  display: flex;
  position: sticky;
  bottom: 0;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #e7e8eb;
  background-color: #fff;
  > div:first-child {
    line-height: 48px;
  }
}
</style>
